module.exports = __webpack_public_path__ + "static/media/warning.6d226ad0.png";